module.exports = __webpack_public_path__ + "bed.svg?ae39f054eea0463b64f965837207ae5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bed.svg
// module id = 2
// module chunks = 0